import { generator_initWorld } from './voyageGameMode_game'
import { voyageMenuMain } from './voyageMenuMain-sidecar'

export function* generator_menuMain(): Generator<number, number, number> {
  voyageMenuMain.setOpen(true)

  yield* generator_initWorld()

  while (true) {
    yield 0
  }
  return 0
}
